export default __webpack_public_path__ + "static/media/bg4.1b52da88.jpg";